import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token inválido ou expirado
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const clienteService = {
  getVilaIsabel: async (params = {}) => {
    try {
      const response = await api.get('/clientes/vila-isabel', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching Vila Isabel clients:', error);
      throw error;
    }
  },

  getNilopolis: async (params = {}) => {
    try {
      const response = await api.get('/clientes/nilopolis', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching Nilópolis clients:', error);
      throw error;
    }
  },

  getAll: async (params = {}) => {
    try {
      const response = await api.get('/clientes/all', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all clients:', error);
      throw error;
    }
  },
};

export default api;

